module.exports = __webpack_public_path__ + "static/biking-10e3d5061942b3d9ce70c8308d2fb2d2.jpg";